import React, { useState, useEffect, useContext } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Container, createMuiTheme, Toolbar, Typography, CssBaseline, Tooltip, Snackbar, FormControl, InputLabel, Select, Divider, TextField, IconButton, AppBar, Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Modules } from '../contexts/modulesContext';
import { Theme } from '../contexts/themeContext';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';
import ExportIcon from '@material-ui/icons/GetApp';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function POSAttendantChecklistAcceptanceReport(props) {
    const classes = useStyles();
    const { defaultSite, sites } = useContext(Context);
    const { trainingMode } = useContext(Modules);
    const { theme } = useContext(Theme);
    const [sitesList, setSitesList] = useState([]);
    const [locations, setlocations] = useState([]);
    const [transactionLog, setTransactionLog] = useState([]);
    const [startDate, setStartDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite));
    const [endDate, setEndDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", 24, defaultSite));
    const [siteId, setSiteId] = useState(-1);
    const [location, setLocation] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const tableHeight = window.innerHeight - (showFilter ? 318 : 210);
    const [successMessage, setSuccessMessage] = useState("");
    const [selectedModel, setSelectedModel] = useState({
        AppPatientSittingId: null,
        RecordCreated: null,
        LocationId: null,
        LocationPath: null,
        Status:null,
        SelectedPOAttendantChecklistAcceptanceReportItem: {}
    });
    const [filter, setFilter] = useState({});
    const [posGroupId, setPOSGroupId] = useState(defaultSite.IntegratedSystem.POSGroupId);

    const getColumns = (posGroupId) => {
        return [
            { field: 'ReportCreatedDate', title: 'Created Date', width: '10%' },
            { field: 'ReportStartDate', title: 'Start Time', width: '15%' },
            { field: 'Attendant', title: 'Attendant', width: '10%' },
            { field: (posGroupId === 1) ? 'Risk' : 'ObservationReasons', title: (posGroupId === 1) ? 'Risk' : 'Observation Reasons', width: '10%' },
            { field: 'LocationPath', title: 'Location', width: '35%' },
            { field: 'Status', title: 'Status', width: '8%' }
        ]
    };

    const [attendantChecklistAcceptances, setAttendantChecklistAcceptances] = useState({
        columns: getColumns(defaultSite.IntegratedSystem.POSGroupId),
        data: []
    });
    const [attendantChecklistDetail, setAttendantChecklistDetail] = useState({});
    const [attendantChecklists, setAttendantChecklists] = useState({
        columns: [
            { field: 'ReportAcceptanceDate', title: 'Acceptance Date', width: '10%' },
            { field: 'Attendant', title: 'Attendant', width: '10%' },
            { field: 'ChargeNurseName', title: 'Charge Nurse/RN’s name', width: '30%' },
            { field: 'Comments', title: 'Comments', width: '30%' },
        ],
        data: []
    });

    const goBack = () => {
        if (showDetail) {
            setShowDetail(false);
        }
        else {
            updateAppTransactionLog();
            props.history.push({ pathname: "/" });
        }
    };

    const rowStyle = (rowData, rowIndex) => {
        return {
            backgroundColor: (rowData.Flag || rowData.Lock) ? "red" : (rowIndex % 2 === 0 ? "" : currentTheme.alternateGridRow)
        };
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
    };

    const filterChanged = () => {
        setShowFilter(!showFilter);
    };

    const siteChanged = (e) => {
        setSiteId(parseInt(e.target.value));
        let index = sites.findIndex(item => item.id === parseInt(e.target.value));
        let groupId = (index === -1) ? 1 : sites[index].IntegratedSystem.POSGroupId;
        if (groupId !== posGroupId) {
            setPOSGroupId(groupId);
            setAttendantChecklistAcceptances({ ...attendantChecklistAcceptances, columns: getColumns(groupId) });
        }

        if (parseInt(e.target.value) > 0) {
            getLocations(parseInt(e.target.value));
        }
        else {
            let data = [];
            data.unshift({ GeoLocationId: 0, GeoLocationBranchName: "All" });
            setlocations(data);
            setLocation(data[0]);
        }
    };
    
    const showAttendantChecklistDetail = (item) => {
        let dto = {};
        dto.AppPatientSittingId = item.Id;
        dto.RecordCreated = item.ReportCreatedDate;
        dto.LocationId = item.LocationId;
        dto.LocationPath = item.LocationPath;
        dto.Status = item.Status;
        dto.SelectedPOAttendantChecklistAcceptanceReportItem = item;
        setSelectedModel(dto);
        setAttendantChecklistDetail(dto);
        getAttendantChecklistsForReport(dto);
        setShowDetail(true);
    };

    const getLocations = (id) => {
        setBackDrop(true);
        HttpService.post("/PatientSitting/GetGeoLocations", {
            siteId: id,
        })
            .then((result) => {
                let data = result.data;
                data.unshift({ GeoLocationId: 0, GeoLocationBranchName: "All" });
                setlocations(data);
                setLocation(data[0]);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getPOAttendantChecklistAcceptanceReport = () => {
        let model = {};
        model.SiteId = siteId;
        model.FilterStartDate = startDate;
        model.FilterEndDate = endDate;
        model.LocationId = (!showFilter || location === null || location.length === 0) ? 0 : location.GeoLocationId;
        model.TrainingMode = trainingMode;
        model.AccessibleSites = sitesList;
        setFilter(model);
        setBackDrop(true);
        HttpService.post("/PatientSitting/GetPOAttendantChecklistAcceptanceReport", model)
        .then((result) => {
            setAttendantChecklistAcceptances({ ...attendantChecklistAcceptances, data: result.data });
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    const getAttendantChecklistsForReport = (dto) => {
        setBackDrop(true);
        HttpService.post("/PatientSitting/GetAttendantChecklistsForReport", dto)
            .then((result) => {
                setAttendantChecklists({ ...attendantChecklists, data: result.data });
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
            });
    };

    const addAppTransactionLog = (reportName, actionType) => {
        HttpService.post("/AppTransactionLog/SaveAppTransactionLog", { ReportName: reportName, ActionType: actionType })
            .then((result) => {
                if (actionType === "Access") {
                    setTransactionLog(result.data);
                }
            },
                (error) => {
                    console.log(error);
                });
    };

    const updateAppTransactionLog = () => {
        HttpService.post("/AppTransactionLog/UpdateAppTransactionLog", transactionLog)
            .then((result) => {
            },
                (error) => {
                    console.log(error);
                });
    };

    const exportToPDF = (reportName) => {
        let model = {};
        let url = "";

        if (reportName === "AttendantChecklistReport") {
            url = "/PatientSitting/ExportAllPDFAttendantChecklistReport";
            model = filter;
        }
        else if (reportName === "AttendantChecklistDetailReport") {

            url = "/PatientSitting/ExportPDFAttendantChecklistDetailReport";
            model = selectedModel;
        }

        setBackDrop(true);
        HttpService.post(url, model)
            .then((result) => {
                if (result.success) {
                    addAppTransactionLog("POS Attendance Checklist Acceptance - Print", "Print");
                    let fileName = result.name;
                    HttpService.downloadFile('/Report/DownloadFile', { fileName: fileName })
                        .then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode.removeChild(link);
                        });
                }
                else {
                    setSuccessMessage(result.message);
                    setOpenSuccess(true);
                }
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        if (sitesList.length > 0) {
            getPOAttendantChecklistAcceptanceReport();
        }
        // eslint-disable-next-line 
    }, [startDate, endDate, location]);

    useEffect(() => {
        getLocations(defaultSite.id);
        let data = sites.slice();
        let index = sites.findIndex(item => item.id === 0);
        if (index === -1) {
            data.unshift({ id: 0, name: "All" });
            setSitesList(data);
        }
        addAppTransactionLog("POS Attendance Checklist Acceptance", "Access");
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        setSiteId(defaultSite.id);
        // eslint-disable-next-line 
    }, [sitesList]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="posObservationBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={goBack} aria-label="back">
                                <KeyboardBackspaceIcon />
                            </IconButton>
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    {!showDetail && <Typography variant="h6" className={classes.title}>Patient Observation Attendant Checklist Acceptance Report</Typography>}
                                    {showDetail && <Typography variant="h6" className={classes.title}>POS Attendant Checklist Report</Typography>}
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                {
                                    (props.location.settingMenus.indexOf("POS Attendance Checklist Acceptance - Print") > -1) && <>
                                        {!showDetail &&
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                className={classes.button}
                                                style={{ background: currentTheme.secondary, width: "120px", marginRight: "10px" }}
                                                startIcon={<ExportIcon />}
                                                type="button"
                                            onClick={e => exportToPDF("AttendantChecklistReport")}
                                            >
                                                Print All
                                            </Button>
                                        }
                                        {showDetail &&
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                className={classes.button}
                                                style={{ background: currentTheme.secondary, width: "120px", marginRight: "10px" }}
                                                startIcon={<ExportIcon />}
                                                type="button"
                                                 onClick={e => exportToPDF("AttendantChecklistDetailReport")}
                                            >
                                                Print Log
                                            </Button>
                                        }
                                    </>}
                                <SmallMenu modified={false} />
                                {!showDetail &&
                                    <Tooltip title="Filter" arrow>
                                        <FilterListIcon style={{ cursor: "pointer", float: "right", width: "30px", marginTop: "20px", marginLeft: "20px" }} onClick={filterChanged} />
                                    </Tooltip>
                                }
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            {!showDetail && <>
                                <div className={classes.root} autoComplete="off">
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}>
                                        <Grid item xs={12} sm={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="StartDate"
                                                    label="Start Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    value={startDate}
                                                    onChange={date => setStartDate(moment(date).format("MM/DD/YYYY"))}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="EndDate"
                                                    label="End Date"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    minDate={startDate}
                                                    value={endDate}
                                                    onChange={date => setEndDate(moment(date).format("MM/DD/YYYY"))}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>
                                    {showFilter && <>
                                        <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                            <InputLabel htmlFor="Site">Site</InputLabel>
                                            <Select
                                                native
                                                label="Site"
                                                size="small"
                                                value={siteId}
                                                onChange={(e) => { siteChanged(e); }}
                                            >
                                                {
                                                    sitesList.map((option, key) => {
                                                        return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                        <Autocomplete
                                            id="Location"
                                            size="small"
                                            openOnFocus
                                            disabled={(siteId <= 0)}
                                            value={location}
                                            options={locations}
                                            getOptionLabel={(option) => option.GeoLocationBranchName || ""}
                                            onChange={(event, option) => setLocation(option)}
                                            renderInput={(params) => <TextField {...params} label="Location" variant="outlined" />}
                                        />
                                    </>
                                    }
                                </div>
                                <Divider style={{ height: "1px", backgroundColor: currentTheme.secondary, marginTop: "5px", marginBottom: "10px" }} />
                                <div style={{ maxWidth: '100%' }}>
                                    <MaterialTable
                                        columns={attendantChecklistAcceptances.columns}
                                        data={attendantChecklistAcceptances.data}
                                        components={{
                                            Toolbar: (props) => (
                                                <div
                                                    style={{
                                                        height: "0px",
                                                    }}
                                                >
                                                    <MTableToolbar {...props} />
                                                </div>
                                            )
                                        }}
                                        style={{ backgroundColor: currentTheme.background, border: "1px solid white" }}
                                        options={{
                                            filtering: false,
                                            search: false,
                                            paging: false,
                                            actionsColumnIndex: -1,
                                            minBodyHeight: tableHeight,
                                            maxBodyHeight: tableHeight,
                                            headerStyle: {
                                                fontWeight: "bold", color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                            },
                                            actionsCellStyle: {
                                                color: currentTheme.secondary,
                                                hover: "white"
                                            },
                                            rowStyle: rowStyle
                                        }}
                                        onRowClick={(evt, selectedRow) => showAttendantChecklistDetail(selectedRow)}
                                    />
                                </div>
                            </>}
                            {showDetail && <>
                                <div className={classes.root} autoComplete="off">
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <TextField
                                                label="Start Date"
                                                size="small"
                                                variant="outlined"
                                                value={attendantChecklistDetail.RecordCreated}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <TextField
                                        label="Location"
                                        size="small"
                                        variant="outlined"
                                        value={attendantChecklistDetail.LocationPath}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        label="Status"
                                        size="small"
                                        variant="outlined"
                                        value={attendantChecklistDetail.Status}
                                        fullWidth
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <div style={{ maxWidth: "100%" }}>
                                        <MaterialTable
                                            columns={attendantChecklists.columns}
                                            data={attendantChecklists.data}
                                            components={{
                                                Toolbar: (props) => (
                                                    <div
                                                        style={{
                                                            height: "0px",
                                                        }}
                                                    >
                                                        <MTableToolbar {...props} />
                                                    </div>
                                                )
                                            }}
                                            style={{ backgroundColor: currentTheme.background, border: "1px solid white" }}
                                            options={{
                                                filtering: false,
                                                search: false,
                                                paging: false,
                                                actionsColumnIndex: -1,
                                                minBodyHeight: window.innerHeight - 315,
                                                maxBodyHeight: window.innerHeight - 315,
                                                headerStyle: {
                                                    fontWeight: "bold", color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                                },
                                                actionsCellStyle: {
                                                    color: currentTheme.secondary,
                                                    hover: "white"
                                                },
                                                rowStyle: rowStyle
                                            }}
                                        />
                                    </div>
                                </div>
                            </>}
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
